<template>
<div>
  <div class="page-header">
    <div class="add-item d-flex">
      <div class="page-title">
        <h4>{{ $t('new_income_head') }}</h4>
        <h6>{{ $t('create_income_head') }}</h6>
      </div>
    </div>
    <ul class="table-top-head">
      <li>
        <div class="page-btn">
          <router-link to="/income/head/list" class="btn btn-added">
            <span>Back</span>
          </router-link>
        </div>
      </li>
      <li>
        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
      </li>
    </ul>
  </div>

  <form @submit.prevent="submitHead" enctype="multipart/form-data">
        <div class="card">
          <div class="card-body add-product pb-0">
            <div class="accordion-card-one accordion" id="accordionExample">
              <div class="accordion-item">
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="mb-3 add-product">
                          <div class="add-newplus">
                            <label class="form-label">{{ $t('category') }} <span class="text-danger">*</span> </label>
                            <a href="#" data-bs-toggle="modal" data-bs-target="#create-modal">
                              <i class="ti ti-circle-plus"></i><span>{{ $t("add_new") }}</span>
                            </a>
                          </div>
                          <FormDropdown
                            v-model="heads.category"
                            :options="formattedCategories"
                            clearable
                            @select="onChangeCategory"
                          />
                          <div v-if="errors.category" class="text-danger">{{ errors.category }}</div>
                        </div>
                      </div>

                      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">{{ $t('name') }} <span class="text-danger">*</span></label>
                          <input
                            type="text"
                            v-model="heads.node"
                            class="form-control"
                            :placeholder="$t('name')"
                          />
                          <div v-if="errors.node" class="text-danger mt-2">
                            <span v-for="(msg, i) in errors.node" :key="i">{{ msg }}</span>
                          </div>
                        </div>
                        <div v-if="errorMessage" class="text-danger mt-2">
                          {{ errorMessage }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <div class="btn-addproduct mb-4">
            <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
            <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('submit') }}</button>
          </div>
        </div>
      </form>

  <CategoryModal
    id="create-modal" @create_success="fetchCategory"
  />

</div>
</template>


<script>
import Modal from "@/components/common/Modal.vue";
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import CategoryModal from "@/views/admin_dashboard/income_head/CreateModal.vue";
import {useToast} from "vue-toastification";

export default {
  components: {
    CategoryModal,
    Modal,
    Vue3Datepicker,
  },

  emits: ['select'],

  data() {
    return {
      heads: {
        p_id: '', node: '', category: null,
      },
      selectedCategory: null,
      categories: [],
      errors: {},
      errorMessage: "",
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  mounted() {
    this.fetchDropdownData();
  },

  computed: {
    formattedCategories() {
      return this.categories.map(cat => ({ id: cat.id, text: cat.node, account_id: cat.account_id }));
    },
  },

  methods: {
      async fetchDropdownData() {
        try {
          const categoriesRes = await this.$axios.get(apiUrls.income_head.get);
          this.categories = categoriesRes?.data || [];

        } catch (error) {
          console.error('Error loading dropdown data:', error);
        }
      },

      onChange(value) {
        this.heads.category = value;

        // Filter sub-categories based on selected category

        this.$emit('select', value);
      },

      onChangeCategory(selected) {
        this.selectedCategory = selected;
        this.heads.category = selected.id;
        this.heads.p_id = selected.account_id;
      },

      fetchCategory(newColor) {
        this.categories.push(newColor);

        this.$nextTick(() => {
          this.heads.category = newColor.id;
          this.heads.p_id = newColor.p_id;
        });
      },

      async submitHead() {
        // Frontend validation before making API call
          this.errors = {};
          if (!this.heads.node.trim()) this.errors.node = this.$t('error.required');
          if (!this.heads.category) this.errors.category = this.$t('error.required');

          if (Object.keys(this.errors).length > 0) {
            return;
        }

        try {
          const payload = {
            ...this.heads,
          };

          // Send API request
          const response = await this.$axios.post(apiUrls.income_head_sub.post, payload, );

          this.toast.success('Income head successfully created!')

          // Redirect only after successful response
          this.$router.push('/income/head/list');

          // Emit event to update parent component
          this.$emit("create_success");

          this.resetForm();
        } catch (error) {
          this.errors = {};
          this.errorMessage = "";

          if (error.response) {
            // Backend field-specific errors
            if (error.response.data?.errors) {
              const backendErrors = error.response.data.errors;

              // Assign to Vue errors object (keep as array)
              Object.keys(backendErrors).forEach(key => {
                this.errors[key] = backendErrors[key];
              });
            }

            // Backend general error message (optional)
            if (error.response.data?.error) {
              this.errorMessage = error.response.data.error;
            }

          } else if (error.request) {
            this.errorMessage = "No response from server. Check network.";

          } else {
            this.errorMessage = error.message;
          }
        }
      },

      cancelForm() {
        this.$router.push('/income/head/list');
      },

      resetForm() {
        // Reset form fields and errors
        this.heads = {
          node: '', category: null
        };
        this.errors = {};
        this.errorMessage = "";
      }
    },

};
</script>
